import { useEffect } from 'react';
import { applyThemePreference } from '../../lib/theme/applyThemePreference.js';
import { readThemePreference } from '../../lib/theme/readThemePreference.js';

/** Draws the saved theme on load and follows the system setting while the preference is "system". */
const ThemeHandler = () => {
  useEffect(() => {
    const preference = readThemePreference({ search: window.location.search, storage: window.localStorage });
    applyThemePreference({ preference, persist: false });

    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const handleSystemChange = () => {
      const current = document.documentElement.dataset.themePreference;
      if (current === 'system') {
        applyThemePreference({ preference: 'system', persist: false });
      }
    };
    media?.addEventListener('change', handleSystemChange);
    return () => media?.removeEventListener('change', handleSystemChange);
  }, []);

  return null;
};

export default ThemeHandler;
